import React from "react"

export function ImagePreview({ properties }) {
  return (
    <div className="flex items-center text-left">
      <div className="w-10 h-10 bg-gray-50 rounded-sm overflow-hidden mr-4">
        <img src={properties.src} alt={properties.alt} className="w-10 h-10" />
      </div>
      <div className="truncate" style={{ width: 150 }}>
        {properties.alt || "Image"}
      </div>
    </div>
  )
}
